import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { ProblemasRequest, Types } from './types';

// ACTIONS
import { problemasSuccess, problemasFailure } from './actions';

function* problemasRequest(request: ReducerAction) {
	const { payload }: { payload: ProblemasRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`grupos-de-problemas/${CHANNEL}/grupos-de-problemas/problemas`,
		payload,
	);

	if (response.status === 200) {
		yield put(problemasSuccess(response));
	} else {
		yield put(problemasFailure(response));
	}
}

export default all([takeLatest(Types.PROBLEMAS_REQUEST, problemasRequest)]);
